/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Metadata_Scan_TitleInputs */

const en_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Metadata Scan`)
};

const fr_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse des metadonnees du media`)
};

const de_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienmetadaten-Scan`)
};

const it_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansione dei metadati multimediali`)
};

const ru_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканирование метаданных медиафайлов`)
};

const es_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escaneo de metadatos de medios`)
};

const zh_cn2_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体元数据扫描`)
};

const ja_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアメタデータスキャン`)
};

const hi_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया मेटाडेटा स्कैन`)
};

const pt_pt2_media_import_metadata_scan_title = /** @type {(inputs: Media_Import_Metadata_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de metadados de mídia`)
};

/**
* | output |
* | --- |
* | "Media Metadata Scan" |
*
* @param {Media_Import_Metadata_Scan_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_metadata_scan_title = /** @type {((inputs?: Media_Import_Metadata_Scan_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Metadata_Scan_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_metadata_scan_title(inputs)
	if (locale === "de") return de_media_import_metadata_scan_title(inputs)
	if (locale === "it") return it_media_import_metadata_scan_title(inputs)
	if (locale === "ru") return ru_media_import_metadata_scan_title(inputs)
	if (locale === "es") return es_media_import_metadata_scan_title(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_metadata_scan_title(inputs)
	if (locale === "ja") return ja_media_import_metadata_scan_title(inputs)
	if (locale === "hi") return hi_media_import_metadata_scan_title(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_metadata_scan_title(inputs)
	return en_media_import_metadata_scan_title(inputs)
});